export const GRADIENTE = 'linear-gradient(90deg, #8531FD 0%, #B996F9 100%)'

export const SECCIONES = ['Sistema Educativo', 'Testimonios', 'Calendario']

export const URLUSUARIO = 'https://usuario.sistemateamtufino.com/?tipo='